import { isEmpty } from 'lodash-es'
import styled from 'styled-components'

import { Layout, Icon, Text } from '@loadsmart/miranda-react'

import { Chat } from 'core/chat/ui/Chat'
import { useChatContext } from 'core/chat/ui/ChatContext'
import { useConversationUnreads } from 'core/chat/ui/hooks/useConversationUnreads'

export const MessagesBoxText = styled(Layout.Group).attrs({
  align: 'center',
  gap: 'spacing-6',
})`
  flex-grow: 1;
`

export type MessageBoxProps = {
  onChatButtonClick?: () => void
}

function UnreadMessages() {
  return (
    <>
      <Icon name="chat" size="24px" color="color-primary-60" />
      <Text color="color-primary-60">You have a new message</Text>
    </>
  )
}

function AllRead() {
  return (
    <>
      <Icon name="chat" size="24px" color="color-text-primary" />
      <Text color="color-text-primary">No messages available</Text>
    </>
  )
}

export function MessagesBox({ onChatButtonClick }: MessageBoxProps) {
  const { isLoading, conversation } = useChatContext()
  const unreads = useConversationUnreads(conversation?.uuid)
  const hasUnread = !isEmpty(unreads)

  return (
    <Layout.Box
      borderColor="color-border-input"
      backgroundColor={hasUnread ? 'color-success-20' : 'color-background-secondary'}
      borderWidth="border-thin"
      paddingX="spacing-6"
      paddingY="spacing-4"
    >
      <Layout.Group align="center">
        {isLoading ? (
          <Text variant="body-sm">Loading chat...</Text>
        ) : (
          <>
            <MessagesBoxText>{hasUnread ? <UnreadMessages /> : <AllRead />}</MessagesBoxText>
            <Chat hasUnread={hasUnread} onClick={onChatButtonClick} />
          </>
        )}
      </Layout.Group>
    </Layout.Box>
  )
}
